import { RefObject, useEffect, useState } from "react";

export const useDynamicAltText = (anchorRef: RefObject<HTMLAnchorElement | HTMLButtonElement | null>) => {
    const [altText, setAltText] = useState('Social');

    useEffect(() => {
        const anchor = anchorRef.current;
        if (!anchor) return;

        const updateAlt = () => {
            const img = anchor.querySelector('img');
            setAltText(img?.alt || 'Social');
        };

        updateAlt(); // Initial

        // const observer = new MutationObserver(updateAlt);
        // observer.observe(anchor, {
        //     childList: true,
        //     subtree: true
        // });

        // return () => observer.disconnect();
    }, [anchorRef]);

    return altText;
};